<template lang="pug">
//- template version for desktop browsing
div(v-if="hideMobile")
  transition(name="searchAnimation" leave-active-class="animated slide-search-bar-up" enter-active-class="animated slideInDown" )
    section#search.search.hero.is-black(v-show="isHomepage || !isHidden" :class="{'is-fixed-top' : !isHomepage, 'is-hidden-touch': hideMobile}")
      .hero-body
        .container
          .columns
            .column.is-8.is-offset-2
              div.field.has-addons
                .control.has-icons-left.is-expanded
                  input.input(type="text", v-bind:placeholder="$t('search.fulltextsearch')",
                      v-model.trim="searchFormString", v-on:keyup.enter.prevent="onSubmit")
                  span.icon.is-small.is-left: i.fa.fa-search
                .control
                  button.button.is-light(v-on:click.prevent="onSubmit") {{ $t("search.search") }}
div.search(v-else-if="permanent")
  form.field.has-addons
    .control.has-icons-left.is-expanded
      input.input(type="text", v-model.trim="searchFormString", v-bind:placeholder="$t('search.fulltextsearch')", v-on:keyup.enter.prevent="onSubmit")
      span.icon.is-small.is-left
        i.fa.fa-search
    .control
      button.button.is-dark(v-on:click.prevent="onSubmit") {{ $t("search.search") }}
  search-facets(:type="'tag'")
//- template version for mobile browsing
form.navbar-item.is-hidden-desktop(v-else)
  .field.has-addons
    .control.has-icons-left.is-expanded
      input.input(type="text", v-bind:placeholder="$t('search.fulltextsearch')", v-model.trim="searchFormString", v-on:keyup.enter.prevent="onSubmit")
      span.icon.is-small.is-left: i.fa.fa-search
    .control
      button.button.is-light(v-on:click.prevent="onSubmitMobile") {{ $t("search.search") }}
</template>

<script>
import SearchFacets from "./SearchFacets";

const throttle = require("lodash.throttle");
const { mapState, mapMutations } = require("vuex");
const { messages } = require("../../i18n/search");

export default {
    name: "SearchForm",
    components: {
        SearchFacets
    },

    data: () => ({ isHidden: false }),
    props: ["context", "permanent"],
    i18n: { messages },

    computed: {
        hideMobile() {
            return this.context === "desktop" ? true : false;
        },

        isHomepage: function() {
            return this.$route.name === "home"
        },

        searchFormString: {
            get: function () {
                return this.$store.state["search"].searchFormString;
            },
            set: function (newValue) {
                this.setsearchFormString(newValue);
            }
        },

        ...mapState("search", {
            messageBus: "searchFormMessageBus",
            queryInState: "query"
        })
    },

    methods: {
        hideOnMobile() {
            // hide search form on mobile devices
            const navbar = document.getElementById("navbar");
            const navbarBurger = navbar.querySelector(".navbar-burger");
            if(navbarBurger.classList.contains("is-active")) {
                navbarBurger.click();
            }
        },

        hideSearchForm() {
            this.isHidden = true;
            this.hideOnMobile();
        },

        onSubmit() { // new query
            if (!this.permanent && !this.isHomepage) {
                this.hideSearchForm();
            }
            if (this.searchFormString === "") {
                return;
            }

            const targetPath = "/suche" + (this.$router.currentRoute.params.section ? `/${this.$router.currentRoute.params.section}`: "");
            this.$router.push({
                path: targetPath,
                query: { q: this.searchFormString }
            });
        },

        onSubmitMobile() {
            // de-activate burger menu
            const html = document.documentElement;
            const navbar = document.querySelector(".navbar");
            const navbarBurger = navbar.querySelector(".navbar-burger");
            const target = document.getElementById(navbarBurger.dataset.target);

            [target, navbarBurger].forEach(el => el.classList.remove("is-active"));
            html.classList.remove("has-navbar-menu-active");

            this.onSubmit();
        },

        showSearchForm() {
            this.isHidden = false;
        },

        ...mapMutations("search", ["setsearchFormString"])
    },

    mounted() {
        registerEventListeners(this);

        if(this.messageBus) {
            this.messageBus.$on("ToggleSearchForm", () => {
                if(!this.permanent) {
                    this.isHidden = !this.isHidden;
                }
                if(this.isHidden) {
                    this.hideOnMobile();
                }
            })
        }

        if(this.permanent) {
            this.searchFormString = this.$route.query.q;
        }
    },

    watch: {
        query(query) {
            this.queryString = query;
        }
    }
};

function registerEventListeners(that) {
    const navbar = document.getElementById("navbar");
    const navbarSearchLogo = navbar.querySelector(".navbar-item[href='#search']");
    const search = document.getElementById("search");
    const isHomepage = that.isHomepage;

    console.log(navbarSearchLogo);

    // register event listener for search logo in navbar
    if (that.context === "desktop") {
        navbarSearchLogo?.addEventListener("click", (e) => {
            e.preventDefault();
            search.classList.toggle("is-active");
            if (search.classList.contains("is-active")) {
                that.showSearchForm();
            }
            else {
                that.hideSearchForm();
            }
        });
    }
    if(!isHomepage) {
        that.hideSearchForm();
    }

    window.addEventListener("scroll", throttle(() => {
        search.classList.remove("is-active");

        if(!isHomepage) {
            that.hideSearchForm();
        }
    }, 500));
}
</script>